import { Component, EventEmitter, Input,  Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { MessageService } from '@mctic/ng-core';
import { ToastrService } from 'ngx-toastr';
import { ModalConfirmacaoComponent } from '../../modal-confirmacao/modal-confirmacao.component';
import { CustomFileValidators } from '../../utilities/file-validators';
import { FileInput } from '../file-input/file-input.model';

@Component({
  selector: 'app-importar-csv',
  templateUrl: './importar-csv.component.html',
  styleUrls: ['./importar-csv.component.scss']
})
export class ImportarCsvComponent {

  form: FormGroup;

  @Input() links: any;
  @Output() importEmitter: EventEmitter<FileInput> = new EventEmitter<FileInput>();

  constructor(private readonly formBuilder: FormBuilder,
    private readonly dialog: MatDialog,
    private readonly toastr: ToastrService,
    private readonly messageService: MessageService,
  ) {
    this.form = this.formBuilder.group({
      arquivo: [null,
        [Validators.required,
         CustomFileValidators.validarExtensao('csv'),
         CustomFileValidators.validarTamanhoMaximoEmBytes(15728640)]],
    });
  }

  importar() {
    if (this.validarForm()) {
      this.importEmitter.emit(this.form.value.arquivo);
    }
  }

  validarForm(): boolean {
    this.form.get('arquivo').markAsTouched({ onlySelf: true });
    this.form.get('arquivo').updateValueAndValidity();
    return this.form.valid;
  }

  cancelar() {
    const dialogRef = this.dialog.open(ModalConfirmacaoComponent, {
      width: '400px',
      data: {
        mensagem: this.messageService.findById('MSG003').description
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.form.reset();
        this.toastr.success(this.messageService.findById('MSG002').description);
      }
    });
  }


}
